
export default function DialogContainer(props) {
    return props.currentDialog ? props.currentDialog : null
}